import Icon from '@/Icon';
import { clc, type BaseProps } from '@/legacy/components/base/utils';
import BulletSplitBodyM16 from '@/legacy/components/Text/BulletSplitBodyM16';
import styles from '@/legacy/components/tournament/openCard.module.scss';
import { nullCashReplace, nullCasualReplace } from '@/utilities/stateTool';
import Image from 'next/image';

type Props = {
	profileSrc: string;
	live: boolean;
	title: string;
	allRound: string;
	round: string;
	type: 'gold' | 'diamond';
	reword: string;
	private: boolean;
	nation: string;
	onClick?: BaseProps['button']['onClick'];
};

const OpenCard = ({ profileSrc, live, title, allRound, round, type, reword, onClick }: Props) => {
	const placeholder = type === 'diamond' ? nullCasualReplace() : nullCashReplace();

	return (
		<button className={styles.openCard} onClick={onClick}>
			<div className={styles.openImages}>
				<Image
					alt={title}
					className={styles.openImage}
					height={100}
					onError={(e) => {
						e.currentTarget.src = placeholder;
						e.currentTarget.alt = 'placeholder image';
					}}
					src={profileSrc}
					width={100}
				/>
				{live ? (
					<Icon className={styles.openLive} path="Sticker_Status_Live" percent1={0.1} />
				) : (
					<Icon className={styles.openLive} path="Sticker_Status_Done" percent1={0.1} />
				)}
			</div>
			<div className={styles.openInfo}>
				<span className={styles.openTitle}>{title}</span>
				<BulletSplitBodyM16 prefix={allRound} suffix={round + (live ? ' 진행중' : '')} />

				<div className={clc(styles.openButton, type === 'diamond' ? styles.casual : styles.cash)}>
					{type === 'diamond' ? (
						<Icon className={styles.openIcon} path="Payment_Image_Diamond_48" />
					) : (
						<Icon className={styles.openIcon} path="Payment_Image_Cash_48" />
					)}
					<span className={styles.text}>{reword}</span>
				</div>
			</div>
		</button>
	);
};

export default OpenCard;
